function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_5217",
  width: 24,
  height: 24,
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_59660",
  d: "M15.64,11.02A10.02,10.02,0,0,1,18.2,7.19a.5.5,0,0,0-.46-.85A8,8,0,0,0,12,14.03h0A9.937,9.937,0,0,1,15.64,11.02ZM11.42,8.85A8.556,8.556,0,0,0,8.46,4.98a.5.5,0,0,0-.72.65A10.886,10.886,0,0,1,9,10.71c0,.21-.03.41-.04.61a10,10,0,0,1,1.22.82A9.911,9.911,0,0,1,11.42,8.85ZM12,20H3a1,1,0,0,1,0-2H7.75a8.027,8.027,0,0,0-4-5.06h0a.486.486,0,0,1-.26-.44.506.506,0,0,1,.49-.5H4A8,8,0,0,1,12,20Zm8.26-7.06h0a8,8,0,0,0-4,5.06H21a1,1,0,0,1,0,2H14a9.828,9.828,0,0,0-.87-4.07A7.97,7.97,0,0,1,20,12h.02a.5.5,0,0,1,.49.5A.488.488,0,0,1,20.26,12.94Z"
});

function SvgGrass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "grass_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrass);
export default __webpack_public_path__ + "static/media/grass.803cf4b1.svg";
export { ForwardRef as ReactComponent };